import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent {
  email = '';
  password = '';
  otp = '';
  loginMode: 'password' | 'otp' = 'password';
  otpRequested = false;
  successMessage = '';
  errorMessage = '';
  isRequestingOtp = false;
  isSubmitting = false;

  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
  }

  selectLoginMode(loginMode: 'password' | 'otp'): void {
    this.loginMode = loginMode;
    this.errorMessage = '';
    this.successMessage = '';
    this.isSubmitting = false;

    if (loginMode === 'password') {
      this.otp = '';
      this.otpRequested = false;
    }
  }

  requestOtp(): void {
    this.errorMessage = '';
    this.successMessage = '';
    this.isRequestingOtp = true;

    this.authService.requestLoginOtp(this.email).subscribe({
      next: () => {
        this.otpRequested = true;
        this.successMessage = 'If the account is active, a sign-in code was sent.';
        this.isRequestingOtp = false;
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = error.error?.message ?? 'Unable to send sign-in code';
        this.isRequestingOtp = false;
      },
    });
  }

  onSubmit(): void {
    this.errorMessage = '';
    this.successMessage = '';
    this.isSubmitting = true;

    const request = this.loginMode === 'otp'
      ? this.authService.login(this.email, undefined, this.otp)
      : this.authService.login(this.email, this.password);

    request.subscribe({
      next: () => {
        const returnUrl = this.route.snapshot.queryParams['returnUrl'] as string | undefined;
        const destination = returnUrl?.startsWith('/') && !returnUrl.startsWith('//')
          ? returnUrl
          : '/';
        void this.router.navigateByUrl(destination);
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = error.error?.message ?? 'Unable to sign in';
        this.isSubmitting = false;
      },
    });
  }
}
